import React from "react";
import styled from "styled-components";
import { formatDate, formatPlan } from "../../services/Utils";
import Button from "./ActionButton";

const TableWrapper = styled.div`
  overflow-x: auto;
  margin-top: 2rem;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  font-size: 1.2rem;
  @media (max-width: 600px) {
    font-size: 1rem;
    min-width: 480px;
  }
  th,
  td {
    padding: 0.8rem 1rem;
    text-align: left;
    border-bottom: 1px solid #eaeaea;
  }
  th {
    background: #fbf1e6;
    color: #22223b;
    font-weight: 600;
  }
`;

const StatusBadge = styled.span`
  padding: 0.2rem 0.8rem;
  border-radius: 1rem;
  font-size: 1rem;
  font-weight: 500;
  color: #fff;
  background: ${({ status }) =>
    status === "COMPLETED" || status === "ACTIVE"
      ? "#00D100"
      : status === "PENDING"
        ? "#fbbf24"
        : status === "CANCELED" || status === "REFUNDED"
          ? "#ff3333"
          : ""};
`;

export function formatPaymentMethod(method) {
  switch (method) {
    case "CREDIT_CARD_STRIPE":
      return "Cartão (Stripe)";
    case "PIX_EFI":
      return "Pix";
    case "PIX_MERCADO_PAGO":
      return "Pix";
    default:
      return method;
  }
}

export default function PaymentsTable({
  payments,
  loading,
  showAction = false,
  onAction,
}) {
  return (
    <TableWrapper>
      <Table>
        <thead>
          <tr>
            <th>Plano</th>
            <th>Data</th>
            <th>Status</th>
            <th>Método</th>
            {showAction && <th>Ação</th>}
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td colSpan={showAction ? 5 : 4}>Carregando...</td>
            </tr>
          ) : payments.length === 0 ? (
            <tr>
              <td colSpan={showAction ? 5 : 4}>Nenhum pagamento encontrado.</td>
            </tr>
          ) : (
            payments.map((p) => (
              <tr key={p.id}>
                <td>{formatPlan(p.subscriptionPlan)}</td>
                <td>{formatDate(p.createdAt)}</td>
                <td>
                  <StatusBadge status={p.status}>
                    {p.status === "COMPLETED"
                      ? "Pago"
                      : p.status === "PENDING"
                        ? "Pendente"
                        : p.status === "CANCELED"
                          ? "Cancelado"
                          : p.status === "FAILED"
                            ? "Falhou"
                            : p.status === "REFUNDED"
                              ? "Reembolsado"
                              : p.status}
                  </StatusBadge>
                </td>
                <td>{formatPaymentMethod(p.paymentMethod)}</td>
                {showAction && (
                  <td>
                    <Button
                      text={"Atualizar"}
                      size={"1"}
                      $NoBgColor
                      action={() => {
                        console.log(p);
                        onAction(p);
                      }}
                    />
                  </td>
                )}
              </tr>
            ))
          )}
        </tbody>
      </Table>
    </TableWrapper>
  );
}
